import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { PersonStanding } from "lucide-react";
import { Dispatch, FC, SetStateAction } from "react";

interface Props {
    showOrders: boolean;
    setShowOrders: Dispatch<SetStateAction<boolean>>;
    ordersLength: number;
}

const ShowOrdersOnMap: FC<Props> = ({showOrders, setShowOrders, ordersLength}) => (
  <div className="relative">
    <Button
      variant={showOrders ? "default" : "outline"}
      className={`py-1 cursor-pointer ${!showOrders && "opacity-50"}`}
      onClick={() => setShowOrders((prev) => !prev)}
      title="Show orders"
    >
      <PersonStanding className="w-4 h-4" />
    </Button>
    {ordersLength > 0 && (
      <Badge className="w-4 h-4 absolute right-0" variant="destructive">
        {ordersLength}
      </Badge>
    )}
  </div>
);

export default ShowOrdersOnMap